import React, {Component} from 'react'
import PrintPage from './PrintPage'

//import PropTypes from 'prop-types'

class PrintPageContainer extends Component {
    render() {
        return (
            <div className='PrintPageContainer'>
                <PrintPage/>
            </div>
        )
    }
}

//PrintPageContainer.defaultProps = {}

//PrintPageContainer.propTypes = {}

export default PrintPageContainer
